import React from "react";
import { CourseGrid } from "@/components/CourseCard";
import { EnquireButton } from "@/components/EnquireButton";

export default function Courses() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
      <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
        <div className="max-w-2xl">
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-[hsl(var(--brand-orange))]">Courses</div>
          <h1 className="mt-2 font-display text-4xl font-bold">Pick the right flight plan</h1>
          <p className="mt-3 text-base text-muted-foreground">Buy any course individually — instant access after secure payment.</p>
        </div>
        <EnquireButton testId="courses-page-enquire" />
      </div>
      <CourseGrid />
    </div>
  );
}
